import * as f from '../../../components/BPMTable/BPMInputs'
import { DataMapper, TableFieldDescription } from '../../../components/BPMTable/TableMapperCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import { DirectTableQueryBuilder } from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";

const unitQuery = `
	user(id: $id) {
		id
		enterpriseId
		firstName
		lastName
	}
`

const queries = {tableQueryBuilder: new DirectTableQueryBuilder('allUsers'), unitQuery};

class InventoryUserMinimalTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "InventoryUserMinimalTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, queries)
		tableCreator.setAdditionalFilters(this.filters)
		tableCreator.addDescriptions([
			new TableFieldDescription(
				'enterpriseId',
				new DataMapper("enterpriseId"),
				new f.FilterDescription(new f.TextFilter("enterpriseId")),
				{label: 'Enterprise Id'}
			),
			new TableFieldDescription(
				'firstName',
				new DataMapper("firstName"),
				new f.FilterDescription(new f.TextFilter("firstName")),
				{label: 'First Name'}
			),
			new TableFieldDescription(
				'lastName',
				new DataMapper("lastName"),
				new f.FilterDescription(new f.TextFilter("lastName")),
				{label: 'Last Name'}
			)
		])

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(InventoryUserMinimalTableCreator)

export default InventoryUserMinimalTableCreator;
